import * as actionlist from '../actions/notinvoicereportlistactions';
import moment from 'moment';
const state = {
    search: '',
    page: 0,
    month: moment().month() + 1,
    year: moment().year(),    
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    month: state => state.month,
    year: state => state.year,    
};

const actions = {
    [actionlist.NOTINVOICEREPORTLIST_SEARCH]: ({ commit }, search) => {
        commit(actionlist.NOTINVOICEREPORTLIST_SEARCH, search);
    },
    [actionlist.NOTINVOICEREPORTLIST_PAGE]: ({ commit }, page) => {
        commit(actionlist.NOTINVOICEREPORTLIST_PAGE, page);
    },
    [actionlist.NOTINVOICEREPORTLIST_MONTH]: ({ commit }, month) => {
        commit(actionlist.NOTINVOICEREPORTLIST_MONTH, month);
    },
    [actionlist.NOTINVOICEREPORTLIST_YEAR]: ({ commit }, year) => {
        commit(actionlist.NOTINVOICEREPORTLIST_YEAR, year);
    },    
};

const mutations = {
    [actionlist.NOTINVOICEREPORTLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [actionlist.NOTINVOICEREPORTLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [actionlist.NOTINVOICEREPORTLIST_MONTH]: (state, month) => {
        state.page = 0;
        state.month = month;
    },
    [actionlist.NOTINVOICEREPORTLIST_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};